import { jsx } from 'react/jsx-runtime';
import { forwardRef, useContext, useMemo } from 'react';
import { getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { TabsContext } from '../TabsContext/index.esm.js';
import './styles.css';


var styles = {
    "tabList": "TabsList-module_tabList__yrs6Q",
    "tabList_multiline": "TabsList-module_tabList_multiline__tos49"
};

const TabRenderComponent = ({ children, context })=>{
    const contextValue = useMemo(()=>context, [
        context
    ]);
    switch(typeof children){
        case 'string':
            return children;
        case 'object':
            if (Array.isArray(children)) {
                return children.map((child, index)=>/*#__PURE__*/ jsx(TabsContext.Provider, {
                        value: {
                            ...contextValue,
                            index
                        },
                        children: child
                    }, `${context.value}-${index}`));
            } else {
                return /*#__PURE__*/ jsx(TabsContext.Provider, {
                    value: {
                        ...contextValue,
                        index: 0
                    },
                    children: children
                }, 0);
            }
        default:
            return '';
    }
};
const TabsList = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, children }, ref)=>{
    const { isMultiline, ...context } = useContext(TabsContext);
    const multilineClassName = isMultiline ? styles.tabList_multiline : '';
    return /*#__PURE__*/ jsx("div", {
        ref: ref,
        id: id,
        className: `${styles.tabList} ${multilineClassName} ${className}`.trim(),
        lang: lang,
        "data-testid": dataTestId,
        role: 'tablist',
        tabIndex: -1,
        children: /*#__PURE__*/ jsx(TabRenderComponent, {
            context: context,
            children: children
        })
    });
});
TabsList.displayName = 'TabsList';

export { TabsList };
